
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's37a9e8aec5713460': `Más`,
's48413f5f20d56eac': `2) Presionar Añadir a pantalla de inicio`,
's6196153c4b0c1ea0': `Instalar`,
's8d0173763d91830c': `Este sitio tiene una funcionalidad de aplicación. Es posible agregarla a la pantalla de inicio para una amplia experiencia y acceso fácil.`,
's9c30494cee3b81dd': `1) Presionar Compartir en la barra de direcciones`,
'sa5ef80b4bb9b39f8': `Menos`,
'sc79fd7641eb9a975': `Esconder instrucciones`,
'scdaf4bbff76674c8': `Añadir a pantalla de inicio`,
'sdca23702207fba73': `Este sitio tiene una funcionalidad de aplicación. Es posible instalarla en este dispositivo para una amplia experiencia y acceso fácil.`,
    };
  